module.exports = __webpack_public_path__ + "static/bottega-7487b5d658efccce8e31e80fbaeba6e2.jpeg";